/* SAGLOU · V4 · Páginas interiores: filtro del catálogo de categoría.
   Los botones [data-sgp-filter] (filtros y «Ver dispositivos» de cada tecnología) muestran solo
   las tarjetas que coinciden y anuncian cuántos productos quedan. */
(function () {
  'use strict';

  function initCat(root) {
    if (!root || root.__sgp) return;
    root.__sgp = true;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.sgp-card'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-sgp-filter]'));
    var bar = Array.prototype.slice.call(root.querySelectorAll('.sgp-filters [data-sgp-filter]'));
    var count = root.querySelector('[data-sgp-count]');
    var empty = root.querySelector('[data-sgp-empty]');
    var shop = root.querySelector('#sgp-catalogo');
    var applied = root.querySelector('[data-sgp-applied]');
    var appliedName = root.querySelector('[data-sgp-applied-name]');
    var label = count ? count.textContent.replace(/^\d+\s*/, '') : '';

    function matches(card, filter) {
      if (filter === 'all') return true;
      var parts = filter.split(':');
      var attr = { zone: 'zones', tech: 'techs', kind: 'kind', cat: 'cats' }[parts[0]];
      if (!attr) return true;
      return (' ' + (card.getAttribute('data-' + attr) || '') + ' ').indexOf(' ' + parts[1] + ' ') !== -1;
    }

    function apply(filter, fromOutside, name) {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = matches(c, filter);
        c.hidden = !ok;
        if (ok) shown++;
      });
      bar.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sgp-filter') === filter ? 'true' : 'false'); });
      var showName = fromOutside && name && filter !== 'all';
      if (applied) { applied.hidden = !showName; if (appliedName) appliedName.textContent = showName ? name : ''; }
      if (count) count.textContent = shown + ' ' + (shown === 1 && count.dataset.one ? count.dataset.one : (count.dataset.many || label)) + (showName ? ' · ' + name : '');
      if (empty) empty.hidden = shown > 0;
      if (fromOutside && shop) {
        shop.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        shop.focus({ preventScroll: true });
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.hasAttribute('data-sgp-reset')) {
          apply('all', false);
          var first = root.querySelector('.sgp-filters [data-sgp-filter="all"]');
          if (first) first.focus({ preventScroll: true });
          return;
        }
        apply(b.getAttribute('data-sgp-filter'), !b.closest('.sgp-filters'), b.getAttribute('data-sgp-label'));
      });
    });
  }

  function boot() { document.querySelectorAll('[data-sgp-cat]').forEach(initCat); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
